import React, {useState, useEffect } from 'react';
import { Modal, Input, Button,  Select, Spin } from 'antd';

import {
    LinkedinShareButton,
    LinkedinIcon,
    FacebookShareButton,
    FacebookIcon,
    TelegramShareButton,
    TelegramIcon,
    TwitterShareButton,
    TwitterIcon,
    FacebookMessengerShareButton,
    FacebookMessengerIcon
} from "react-share";

import {CopyToClipboard} from 'react-copy-to-clipboard';

import { FormattedMessage, useIntl } from 'react-intl';

import { openNotificationWithIcon } from '../../../Utility/notificationMessage';

import { CopyOutlined } from '@ant-design/icons';

import { academyConst } from '../academy';

import parse from 'html-react-parser';

//API
import userAPI from 'app/API/user.service.api';
import { academyAPI } from 'app/API/academy.api';

const { Option } = Select;


export const shareMessages = {
    notification: {
        id: 'Copied',
        defaultMessage: 'Copied',
    },
    emailSend: {
        id: 'Enter e-mail to share your certificate',
        defaultMessage: 'Enter e-mail to share your certificate',
    },
    sent: { id: 'Send', defaultMessage: 'Send' },
    notificationSend: {
        id: 'Select friends notify that you have achieved a certificate',
        defaultMessage: 'Select friends to share certificate by notification',
    }, 
    success: { id: 'Success', defaultMessage: 'Success' },
    error: {
        id: 'Something went wrong, please refresh the page',
        defaultMessage: 'Something went wrong, please refresh the page',
    },
};


const ShareComponent = ({state, changeState, user, isLoggedIn, lists}) => {
    const {activeListKey, activeLessonKey, shareModalShow, shareType} = state;

    const activelist = lists.filter(item => item.id === activeListKey )[0];
    
    const intl = useIntl();

    const [friendList, setFriendList] = useState([]);
    const [selectedFriends, setSelectedFriends] = useState([]);
    const [emailInput, setEmailInput] = useState('');
    const [cerId, setCetId] = useState(0);
    const [loading, setLoading] = useState(false);
    const [loadingEmail, setLoadingEmail] = useState();

    useEffect(() => {
        if(isLoggedIn && user && user.id){
            userAPI.getFriendsById(user.id)
            .then(res => {
                const { code, friends } = res;
                if (code === 200) {
                    setFriendList(friends);
                } else {
                    console.log(res);
                }
            })
            .catch(err => console.log(err));
        }

        return () => {
            setFriendList([]);
            setCetId(0);
        }
    }, [isLoggedIn])

    useEffect(() => {
        state.certificateIdByListId.map(item => {
            if(item.list_id === state.activeListKey){
                setCetId(item.certificate_id);
            }
        })
        return () => {
            setCetId(0);
        }
    }, [state.certificateIdByListId])

    const text = {
        notification: intl.formatMessage(shareMessages.notification),
        emailSend:  intl.formatMessage(shareMessages.emailSend),
        sent: intl.formatMessage(shareMessages.sent),
        notificationSend: intl.formatMessage(shareMessages.notificationSend),
        success:intl.formatMessage(shareMessages.success),
        error: intl.formatMessage(shareMessages.error),
    }

    const getUrl = () => {
        let url = `${process.env.SERVER_URL}/touracademy?list=${activeListKey}`
        if(shareType === academyConst.LESSON){
            url = `${process.env.SERVER_URL}/touracademy?list=${activeListKey}&lesson=${activeLessonKey}`
        }
        return url;
    }

    const handleChange = (value) => setSelectedFriends(value);

    const shareWithEmail = () => {
        const { title } = activelist;
        setLoadingEmail(true);
        academyAPI.shareCertirficateByEmail(emailInput, title, cerId, user.id, activeListKey)
        .then(res => {
            const {code} = res;
            if(code === 200){
                openNotificationWithIcon("success", text.success);
            }
            setLoadingEmail(false);
            setEmailInput('');
        })
        .catch(err => {
            setLoadingEmail(false);
            openNotificationWithIcon("error", err.message ? err.message : "ERROR")
        });
    }

    const shareWithNotification = (listId, title) => {
        setLoading(true);
        academyAPI.sendNotificationToFriend(cerId, selectedFriends, user.id, listId, title)
        .then(res => {
            const {code} = res;
            if(code === 200){
                openNotificationWithIcon("success", text.success)
            }
            setLoading(false);
            setSelectedFriends([]);
        })
        .catch(err => {
            setLoading(false);
            openNotificationWithIcon("error", err.message ? err.message : "ERROR")
        });
    }

    const handleOnChange = (e) => setEmailInput(e.target.value);
 

    return(
        <Modal
            centered
            visible={shareModalShow}
            footer={false}
            closable={true}
            maskClosable={true}
            onCancel={() => changeState({shareModalShow: false})}
            className="academy_share"
            title={intl.formatMessage({id: 'Share', defaultMessage: 'Share'})}
        >   
            <div>
                <div className="share_icons">
                    <div className='share_icon_item'>
                        <FacebookShareButton url={getUrl()}>
                            <FacebookIcon size={44} round={true}/>
                            <span>Facebook</span>
                        </FacebookShareButton>
                    </div>
                    <div className='share_icon_item'>
                        <FacebookMessengerShareButton url={getUrl()} appId="1587425094819221">
                            <FacebookMessengerIcon size={44} round={true}/>
                            <span>Messenger</span>
                        </FacebookMessengerShareButton>
                    </div>
                    <div className='share_icon_item'>
                        <LinkedinShareButton url={getUrl()}>
                            <LinkedinIcon size={44} round={true}/>
                            <span>Linkedin</span>
                        </LinkedinShareButton>
                    </div>
                    <div className='share_icon_item'>
                        <TelegramShareButton url={getUrl()}>
                            <TelegramIcon size={44} round={true}/>
                            <span>Telegram</span>
                        </TelegramShareButton>
                    </div>
                    <div className='share_icon_item'>
                        <TwitterShareButton url={getUrl()}>
                            <TwitterIcon size={44} round={true}/>
                            <span>Twitter</span>
                        </TwitterShareButton>
                    </div>
                </div>
                <div>
                    <div className="title">
                        <FormattedMessage id="Page Link" defaultMessage="Page Link"/>
                    </div>
                    <div className="copy_link">
                        <Input value={getUrl()} disabled/>
                        <CopyToClipboard 
                            text={getUrl()}
                            onCopy={() => openNotificationWithIcon("success", text.notification)}
                        >
                            <Button>
                                <CopyOutlined />
                            </Button>
                        </CopyToClipboard>
                    </div>
                </div>
                {activeLessonKey === 'last' ? (
                    <div>
                        <div className="title">
                            <FormattedMessage id="Share certificate with your friends" defaultMessage="Share certificate with your friends"/>
                        </div>
                        <div className="copy_link" style={{marginBottom: 10}}>
                            <Input placeholder={text.emailSend} onChange={handleOnChange} />
                            <Button onClick={() => shareWithEmail()}>{loadingEmail ? <Spin size="small"/> : text.sent}</Button>
                        </div>
                        <div className="copy_link">
                            <Select value={selectedFriends} mode="tags" style={{ width: '100%' }} placeholder={text.notificationSend} onChange={handleChange} showSearch={false}>
                                {friendList.map(item => <Option value={`${item.id}`} key={item.id}>{parse(item.name)}</Option>)}
                            </Select>
                            <Button onClick={() => shareWithNotification(activeListKey, activelist.title)}>{loading ? <Spin size="small"/> : text.sent}</Button>
                        </div>
                    </div>
                ) : (null)}
            </div>

        </Modal>
    )
}


export default ShareComponent;